module.exports = __webpack_public_path__ + "img/BusinessCoaching.6a28ddb4.jpg";